import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SessionExpiredDialogComponent } from './session-expired-dialog.component';
import { ButtonModule } from 'primeng/button';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule
  ],
  declarations: [SessionExpiredDialogComponent],
  exports: [SessionExpiredDialogComponent]
})
export class SessionExpiredDialogModule { }
